export default "__VITE_ASSET__CIqwM88U__"